export const Issue = {
    path: '/issues',
    name: 'issues',
    component: () => import('@/views/Notification/IssuePage.vue'),
    children: [
        {
            path: '/issues/workers/view/:id',
            name: 'issues.workers.view',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/issues/contrats/view/:id',
            name: 'issues.contrats.view',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: { viewAction: true }
        },
    ]
}